'use es6';

import { combineReducers } from 'redux';
import ProfileReviewability from 'marketplace-ui-reviews/records/ProfileReviewability';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import ProfileListing from 'ecosystem-marketplace-core/records/ProfileListing';
import * as ActionTypes from '../../actions/ActionTypes';

const details = (state = new ProfileListing(), action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_LISTING_RECEIVED:
      return ProfileListing.from(action.payload);

    case ActionTypes.PROFILE_REVIEWABILITY_RECEIVED:
      {
        return state.merge({
          reviewability: new ProfileReviewability(action.payload)
        });
      }

    case ActionTypes.PROFILE_REVIEW_SUMMARY_RECEIVED:
      {
        return state.merge({
          reviewSummary: action.payload
        });
      }

    default:
      return state;
  }
};

const detailsRequestError = (state = null, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_LISTING_REQUESTED:
      return null;

    case ActionTypes.PROFILE_LISTING_FAILED:
      return action.payload;

    default:
      return state;
  }
};

const detailsRequestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_LISTING_REQUESTED:
      return RequestState.PENDING;

    case ActionTypes.PROFILE_LISTING_RECEIVED:
      return RequestState.SUCCEEDED;

    case ActionTypes.PROFILE_LISTING_FAILED:
      return RequestState.FAILED;

    default:
      return state;
  }
};

const reviewabilityRequestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_REVIEWABILITY_REQUESTED:
      return RequestState.PENDING;

    case ActionTypes.PROFILE_REVIEWABILITY_RECEIVED:
      return RequestState.SUCCEEDED;

    case ActionTypes.PROFILE_REVIEWABILITY_FAILED:
      return RequestState.FAILED;

    default:
      return state;
  }
};

const reviewSummaryRequestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_REVIEW_SUMMARY_REQUESTED:
      return RequestState.PENDING;

    case ActionTypes.PROFILE_REVIEW_SUMMARY_RECEIVED:
      return RequestState.SUCCEEDED;

    case ActionTypes.PROFILE_REVIEW_SUMMARY_FAILED:
      return RequestState.FAILED;

    default:
      return state;
  }
};

export default combineReducers({
  details,
  detailsRequestError,
  detailsRequestState,
  reviewabilityRequestState,
  reviewSummaryRequestState
});